// import React from "react";
// import { motion } from "framer-motion";

// import { AppWrap } from "../../wrapper";
// import { images } from "../../constants";
// import "./Header.scss";

// const scaleVariants = {
//   whileInView: {
//     scale: [0, 1],
//     opacity: [0, 1],
//     transition: {
//       duration: 1,
//       ease: "easeInOut",
//     },
//   },
// };

// const Header = () => (
//   <div className="app__header app__flex">
//     <motion.div
//       whileInView={{ x: [-100, 0], opacity: [0, 1] }}
//       transition={{ duration: 0.5 }}
//       className="app__header-info"
//     >
//       <div className="app__header-badge">
//         <div className="badge-cmp app__flex">
//           <span>👋</span>
//           <div style={{ marginLeft: 20 }}>
//             <p className="p-text">Hello, my name is</p>
//             <h1 className="head-text">Nattarach (Rise) Larptaweepornsup</h1>
//           </div>
//         </div>

//         <div className="tag-cmp app__flex">
//           <p className="p-text">
//             I'm a Junior studying Computer Science and Data Science
//           </p>
//           <p className="p-text">at University of Wisconsin Madison</p>
//           <p className="p-text">Actively seeking for Summer Internship!</p>
//         </div>
//         <div className="resume app__flex">
//           <a
//             href="https://drive.google.com/uc?export=download&id=1pEzok81zBfzkAR8Nvo29LB9FP-cTFuLF"
//             download="Nattarach_Larptaweepornsup_Resume_2025.pdf"
//             target="_blank"
//           >
//             <p className="p-text">download my resume</p>
//           </a>
//         </div>
//       </div>
//     </motion.div>

//     <motion.div
//       whileInView={{ opacity: [0, 1] }}
//       transition={{ duration: 0.5, delayChildren: 0.5 }}
//       className="app__header-img"
//     >
//       <img src={images.profile} alt="profile_bg" />
//       <motion.img
//         whileInView={{ scale: [0, 1] }}
//         transition={{ duration: 1, ease: "easeInOut" }}
//         src={images.circle}
//         alt="profile_circle"
//         className="overlay_circle"
//       />
//     </motion.div>

//     <motion.div
//       variants={scaleVariants}
//       whileInView={scaleVariants.whileInView}
//       className="app__header-circles"
//     >
//       {[images.java, images.python2, images.javascript].map((circle, index) => (
//         <div className="circle-cmp app__flex" key={`circle-${index}`}>
//           <img src={circle} alt="profile_bg" />
//         </div>
//       ))}
//     </motion.div>
//   </div>
// );

// export default AppWrap(Header, "home");

import React from "react";
import { motion } from "framer-motion";
import { AppWrap } from "../../wrapper";
import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          <span>👋</span>
          <div style={{ marginLeft: 20 }}>
            <p className="p-text">Hello, my name is</p>
            <h1 className="head-text">Nattarach (Rise) Larptaweepornsup</h1>
          </div>
        </div>

        <div className="tag-cmp app__flex">
          <p className="p-text">📌 CS & Data Science @ UW-Madison (3.929 GPA)</p>
          <p className="p-text">⚡ Software Engineer | Data Solutions Builder</p>
          <p className="p-text">🚀 Actively seeking full-time SWE roles starting July 2025</p>
        </div>



        <div className="resume app__flex">
          <a
            href="https://drive.google.com/uc?export=download&id=1bb4tt9dOHEqCSrOCpPQjcqbmliSHfYuh"
            download="Nattarach_Larptaweepornsup_Resume_2025.pdf"
            target="_blank"
          >
            <p className="p-text">download my resume</p>
          </a>
        </div>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <img src={images.profile} alt="profile_bg" />
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: "easeInOut" }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[images.python2, images.javascript, images.react].map((circle, index) => (
        <div className="circle-cmp app__flex" key={`circle-${index}`}>
          <img src={circle} alt="tech" />
        </div>
      ))}
    </motion.div>
  </div>
);

export default AppWrap(Header, "home");